import React from "react";
import { Link } from "react-router-dom";
import ServiceListingData from "../Data/ServiceListingData";

const Services = () => {
  return (
    <>
      <section className="services-area section-gap" id="services">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content  col-lg-8">
              <div className="title text-center">
                <h1 className="mb-10">Our Services</h1>
                <p>
                  Create an individual identity of your business from our wide
                  range of services
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {ServiceListingData?.map((service) => (
              <div className="col-lg-4 col-md-6" key={service.id}>
                <div className="single-services">
                  <span className={service.serviceIcon}></span>
                  <Link to={service.serviceUrl}>
                    <h4>{service.serviceName}</h4>
                  </Link>
                  <p>{service.serviceDescription}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Link
              id="first-btn"
              className="primary-btn text-uppercase"
              to="/packages"
            >
              Explore our Packages
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
